import React, { Component } from 'react'
import { Row, Col } from 'antd'
import { compose, gql, graphql, withApollo, ApolloClient } from 'react-apollo'
import PropTypes from 'prop-types'

import Profile from './Components/Profile'
import RegistrationItem from './Components/RegistrationItem'
import './styles.css'
import { DashBoardBox } from '~/styles'

class DashboardPage extends Component {
  // componentWillMount() {
  //   console.log()
  // }
  static propTypes = {
    client: PropTypes.instanceOf(ApolloClient).isRequired
  }

  handleSubmit = ({ registrationId }) => {
    this.props
      .submitRegistration({
        variables: { _id: registrationId }
      })
      // .then(console.log)
  }

  render () {
    const { client } = this.props
    const data = client.readQuery({
      query: gql`
        {
          currentUser {
            _id
            email
            profile {
              firstName
              lastName
            }
          }
        }
      `
    })
    const { profile } = data.currentUser

    const { registrations } = this.props.data

    return (
      <DashBoardBox>
        <Row>
          <Col xs={24} md={8}>
            <Profile profile={profile} registrations={registrations} />
          </Col>
          {registrations &&
            <Col xs={24} md={16}>
              {registrations.map(registration => (
                <RegistrationItem
                  registration={registration}
                  key={registration._id}
                  onSubmit={this.handleSubmit}
                />
              ))}
            </Col>}
        </Row>
      </DashBoardBox>
    )
  }
}

// const DashboardPageWithApollo = withApollo(DashboardPage)

// console.log(this.props.client)
const registrationsQuery = gql`query registrations {
  registrations {
    _id
    code
    status
    expired
    expireAt
    amount {
      total
      discount
      discounted
    }
    event {
      _id
      slug
      isRegOpen
      settings {
        _id
        ticket {
          _id
          hideNumber
        }
      }
      name {
        en
        th
      }
      periods {
        _id
        start
        end
        preRegisterStart
        preRegisterEnd
      }
    }
    participants {
      _id
      profile {
        _id
        firstName
        lastName
      }
      tickets {
        _id
        number
      }
    }
    successfulPayment {
      _id
      amount
      method
    }
    registrationType {
      _id
      name {
        en
        th
      }
    }
  }
}`

const submitRegistrationMutation = gql`mutation submitRegistrationMutation ($_id: MongoID!) {
  submitRegistration(_id: $_id) {
    _id
    status
  }
}`

// code
// status
// userId
// eventId
// vipCode
// createdAt
// updatedAt
// _id
export default compose(
  graphql(registrationsQuery, {
    options: {
      fetchPolicy: 'cache-and-network'
    }
  }),
  graphql(submitRegistrationMutation, {
    name: 'submitRegistration'
  }),
  withApollo
)(DashboardPage)



// WEBPACK FOOTER //
// ./src/App/DashboardPage/DashboardPage.js